'use client';
/**
 * Набор параметров функции `randomId`.
 * */ /**
 * Генерирует случайную строку указанной длины.
 * @param options - Набор параметров
 * @returns Случайная строка
 * */ function randomId(options) {
    const { length = 8, radix = 36, prefix = '' } = options || {};
    const randomString = Math.random().toString(radix).slice(2, 2 + length);
    return `${prefix}${randomString}`;
}

export { randomId };
//# sourceMappingURL=randomId.js.map
